import toast from '../../components/Toast';
import { useEffectAfterMount } from './effect';
/** trigger a success toast with a message on boolean changes with optional callback */
export var useSuccessToast = function (message, watchers, callback) {
    if (message === void 0) { message = 'Success'; }
    if (watchers === void 0) { watchers = []; }
    if (callback === void 0) { callback = function () { return null; }; }
    useEffectAfterMount(function () {
        if (watchers.every(function (w) { return !!w; })) {
            toast.success(message);
            callback();
        }
    }, watchers);
};
/** trigger an error toast with a message on boolean changes with optional callback */
export var useErrorToast = function (message, watchers, callback) {
    if (message === void 0) { message = 'Error'; }
    if (watchers === void 0) { watchers = []; }
    if (callback === void 0) { callback = function () { return null; }; }
    useEffectAfterMount(function () {
        if (watchers.every(function (w) { return !!w; })) {
            toast.error(message);
            callback();
        }
    }, watchers);
};
